import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { FilterChip } from '../FilterChip/FilterChip';
import { localizeMode, selectedMode, togglePredicate } from './EffectiveDateModeChip.utils';
export const GetEffectiveDateModeChipTID = (parentTestId)=>getTestIds(parentTestId);
export const EffectiveDateModeChip = (param)=>{
    let { testId, predicate, onChange } = param;
    const { t } = useLocaleKeys('pages.draftsDashboard.aiSearch');
    const mode = selectedMode(predicate);
    return /*#__PURE__*/ _jsx(FilterChip, {
        testId: testId,
        fieldLabel: t.effectiveDateModeLabel(),
        valueLabel: localizeMode(mode, t),
        onValueClick: ()=>onChange(togglePredicate(predicate)),
        onRemove: ()=>onChange(undefined),
        removeBiName: "drafts_ai_search_chip_remove_effective_date_mode"
    });
};
